module.exports = __webpack_public_path__ + "media/images/count-box-bg-purple-cf5a3339.svg";